/**
 * @see https://umijs.org/docs/max/access#access
 * */
import { salesPlatformNavigation } from './pages/frontend/permissions';

export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const permissions = currentUser?.access;
  if (!permissions || typeof permissions !== 'object') return permissions;
  const granted = permissions as Record<string, unknown>;
  const systemNavigation = Boolean(
    granted['menu:system'] ||
      granted.system ||
      granted['material:list'] ||
      granted['short-link:list'] ||
      granted.systemOperationLog,
  );
  return {
    ...granted,
    ...salesPlatformNavigation(granted),
    meetingSalesActivityWorkspace: [
      'Activity',
      'Registration',
      'Group',
      'Members',
      'Booking',
      'Rooming',
    ].some((page) =>
      [
        'List',
        'Edit',
        'Review',
        'Delete',
        'Export',
        'Auto',
        'Import',
        'Leaders',
        'Share',
        'CheckinCode',
        'StopRegistration',
        'ResumeRegistration',
      ].some((action) => granted[`meetingSales${page}${action}`]),
    ),
    meetingSalesHotelWorkspace: ['Hotel', 'Room', 'Booking', 'Rooming'].some(
      (page) =>
        [
          'List',
          'Edit',
          'Review',
          'Delete',
          'Export',
          'Auto',
          'Import',
          'Leaders',
          'Share',
          'CheckinCode',
        ].some((action) => granted[`meetingSales${page}${action}`]),
    ),
    systemNavigation,
    'menu:systemNavigation': systemNavigation,
  };
}
